<template>
  <v-main>
    <v-container fluid>
      <v-row>
        <v-col md="12">
          <v-card elevation="6" rounded="xxl">
            <v-card-title>
              <h3
                class="font-weight-bold"
                v-text="isDeletePage() != true ? 'Gifts' : 'Deleted Gifts'"
              ></h3>
              <template v-if="isDeletePage() != true">
                <v-btn
                  v-if="can('GIFTS.CREATE')"
                  class="mx-2 mb-2"
                  fab
                  x-small
                  color="primary"
                  to="/gifts/create"
                >
                  <v-icon dark> mdi-plus </v-icon>
                </v-btn>
              </template>
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-col md="6">
                  <v-text-field
                    solo
                    rounded
                    v-model="filter.search_keyword"
                    label="Search ... "
                    color="#e60040"
                    prepend-inner-icon="mdi-magnify"
                    clearable
                    @click:clear="
                      (filter.search_keyword = null), (page = 1), getData()
                    "
                    @keydown.enter="(page = 1), getData()"
                  >
                  </v-text-field>
                </v-col>
                <v-col sm="3">
                  <v-autocomplete
                    ref="status"
                    solo
                    rounded
                    v-model="filter.is_active"
                    :items="statuses"
                    clearable
                    @click:clear="(filter.is_active = null), (page = 1)"
                    label="Status"
                    @input="getData"
                    prepend-inner-icon="mdi-toggle-switch"
                  ></v-autocomplete>
                </v-col>
                <v-col sm="3">
                  <v-autocomplete
                    ref="gift_type"
                    solo
                    rounded
                    v-model="filter.gift_type_id"
                    :items="giftTypeItems"
                    item-text="text"
                    item-value="id"
                    clearable
                    @click:clear="(filter.gift_type_id = null), (page = 1)"
                    label="Gift Type"
                    @input="getData"
                    prepend-inner-icon="mdi-gift"
                  ></v-autocomplete>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <!-- Gift Type-wise Gifts Display -->
      <v-row v-if="isLoading">
        <v-col md="12">
          <v-card elevation="6" rounded="xxl">
            <v-card-text>
              <section style="height: 285px">
                <v-progress-linear
                  indeterminate
                  color="primary"
                ></v-progress-linear>
              </section>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <v-row v-else>
        <v-col
          v-for="(giftTypeGroup, giftTypeName) in groupedGifts"
          :key="giftTypeName"
          md="12"
        >
          <v-card elevation="6" rounded="xxl" class="mb-4">
            <v-card-title class="primary white--text">
              <v-icon class="mr-2" color="white">mdi-gift</v-icon>
              <h3>{{ giftTypeName }}</h3>
              <v-spacer></v-spacer>
              <v-chip color="white" text-color="primary">
                {{ giftTypeGroup.items.length }} Gifts
              </v-chip>
            </v-card-title>
            <v-card-text>
              <v-simple-table class="striped-table">
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left">Sr No</th>
                      <th class="text-left">Status</th>
                      <th class="text-left">Gift Image</th>
                      <th class="text-left">Gift Name</th>
                      <th class="text-left">Price</th>
                      <th class="text-left">VIP Level</th>
                      <th class="text-left">Event Type</th>
                      <th class="text-right">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(gift, i) in giftTypeGroup.items"
                      :key="`gift_${i}`"
                      :class="{
                        'table-row-even': i % 2 === 0,
                        'table-row-odd': i % 2 !== 0,
                      }"
                    >
                      <td style="min-width: 85px">
                        {{ i + 1 }}
                      </td>
                      <td>
                        <v-tooltip bottom v-if="gift.is_active == 1">
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip
                              v-bind="attrs"
                              v-on="on"
                              small
                              color="teal"
                              text-color="white"
                            >
                              <v-avatar left>
                                <v-icon size="15"
                                  >mdi-checkbox-marked-circle</v-icon
                                >
                              </v-avatar>
                              Active
                            </v-chip>
                          </template>
                          <span>Gift is Active</span>
                        </v-tooltip>
                        <v-tooltip bottom v-if="gift.is_active == 0">
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip
                              v-bind="attrs"
                              v-on="on"
                              small
                              color="red"
                              text-color="white"
                            >
                              <v-avatar left>
                                <v-icon size="15">mdi-close-circle</v-icon>
                              </v-avatar>
                              Inactive
                            </v-chip>
                          </template>
                          <span>Gift is InActive</span>
                        </v-tooltip>
                      </td>
                      <td>
                        <v-avatar size="50" v-if="gift.image_path">
                          <v-img :src="`${mediaUrl}${gift.image_path}`"></v-img>
                        </v-avatar>
                        <v-avatar size="50" v-else color="grey lighten-2">
                          <v-icon>mdi-image-off</v-icon>
                        </v-avatar>
                      </td>
                      <td>
                        {{ gift.name || "" }}
                      </td>
                      <td>
                        <v-chip small color="amber" text-color="white">
                          <v-icon left small>mdi-bitcoin</v-icon>
                          {{ gift.price || 0 }}
                        </v-chip>
                      </td>
                      <td>
                        VIP {{ gift.vip_level ? gift.vip_level.level : "-" }}
                      </td>
                      <td>
                        {{ gift.event_type || "-" }}
                      </td>
                      <td class="text-right">
                        <template v-if="isDeletePage() != true">
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                fab
                                x-small
                                class="my-auto ml-1"
                                color="primary"
                                :to="`/gifts/${encryptIt(gift.id)}/user-gifts`"
                              >
                                <v-icon dark>mdi-content-duplicate</v-icon>
                              </v-btn>
                            </template>
                            <span>View User Gifts</span>
                          </v-tooltip>
                          <v-tooltip bottom v-if="can('GIFTS.UPDATE')">
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                fab
                                x-small
                                class="my-auto ml-1"
                                color="primary"
                                :to="`/gifts/${encryptIt(gift.id)}`"
                              >
                                <v-icon dark> mdi-pencil </v-icon>
                              </v-btn>
                            </template>
                            <span>Edit this Gift</span>
                          </v-tooltip>
                          <v-tooltip bottom v-if="can('GIFTS.DELETE')">
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                fab
                                x-small
                                class="my-auto ml-1"
                                color="error"
                                @click="Delete_this(gift.id)"
                              >
                                <v-icon dark> mdi-delete </v-icon>
                              </v-btn>
                            </template>
                            <span>Delete this Gift</span>
                          </v-tooltip>
                        </template>
                        <template v-else>
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                fab
                                x-small
                                class="my-auto"
                                color="success"
                                @click="Restore_this(gift.id)"
                              >
                                <v-icon dark> mdi-delete-restore </v-icon>
                              </v-btn>
                            </template>
                            <span>Restore this Gift</span>
                          </v-tooltip>
                        </template>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
              <v-divider class="my-3"></v-divider>
            </v-card-text>
          </v-card>
        </v-col>

        <!-- No Data Found -->
        <v-col md="12" v-if="Object.keys(groupedGifts).length === 0">
          <v-card elevation="6" rounded="xxl">
            <v-card-text class="text-center">
              <v-icon size="64" color="grey">mdi-gift-off</v-icon>
              <h3 class="mt-3">No gifts found</h3>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <!-- Pagination -->
      <v-row v-if="!isLoading && Object.keys(groupedGifts).length > 0">
        <v-col md="12">
          <v-card elevation="6" rounded="xxl">
            <v-card-text>
              <v-pagination rounded v-model="page" :length="paginationLength">
              </v-pagination>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <!-- Delete Success Dialog Box -->
      <v-dialog v-model="is_deleted_gift" width="600">
        <v-card rounded="xxl">
          <v-container>
            <v-row align="center">
              <v-col sm="3" align="center">
                <v-icon
                  large
                  style="color: green; font-size: 90px; width: 200px !important"
                >
                  mdi-delete-empty
                </v-icon>
              </v-col>
              <v-col sm="9" align="center">
                <v-card-text>
                  <v-row>
                    <v-col>
                      <h1 style="color: green">Hurray!</h1>
                      <br />
                      <h3>Gift deleted successfully.</h3>
                      <br />
                      <v-btn color="success" @click="is_deleted_gift = false">
                        OK
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-dialog>
      <!-- Restore Success Dialog Box -->
      <v-dialog v-model="is_restored_gift" width="600">
        <v-card rounded="xxl">
          <v-container>
            <v-row align="center">
              <v-col sm="3" align="center">
                <v-icon
                  large
                  style="color: green; font-size: 90px; width: 200px !important"
                >
                  mdi-delete-restore
                </v-icon>
              </v-col>
              <v-col sm="9" align="center">
                <v-card-text>
                  <v-row>
                    <v-col>
                      <h1 style="color: green">Hurray!</h1>
                      <br />
                      <h3>Gift restored successfully.</h3>
                      <br />
                      <v-btn color="success" @click="is_restored_gift = false">
                        OK
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-dialog>
    </v-container>
  </v-main>
</template>

<script>
import axios from "axios";
export default {
  name: "giftsPage",
  data() {
    return {
      filter: {
        search_keyword: "",
        is_active: "",
        gift_type_id: "",
      },
      gifts: [],
      giftTypeItems: [],
      statuses: [
        {
          id: 0,
          text: "Select Active Status",
          value: "",
        },
        { id: "ACTIVE", text: "ACTIVE", value: "1" },
        { id: "INACTIVE", text: "INACTIVE", value: "0" },
      ],
      page: 1,
      serialNoStarting: 1,
      paginationLength: 0,
      count: 0,
      excel_fields: {
        "Sr No": "sr_no",
        Name: "name",
        Price: "price",
      },
      isLoading: false,
      isExcelloading: false,
      delete_gift: false,
      restore_gift: false,
      is_deleted_gift: false,
      is_restored_gift: false,
    };
  },
  watch: {
    page: "getData",
    $route() {
      this.getData();
    },
  },
  computed: {
    groupedGifts() {
      // Group gifts by gift_type
      const grouped = {};
      this.gifts.forEach((gift) => {
        const giftTypeName = gift.gift_type
          ? gift.gift_type.description
          : "Uncategorized";
        const giftTypeId = gift.gift_type ? gift.gift_type.id : null;

        if (!grouped[giftTypeName]) {
          grouped[giftTypeName] = {
            giftTypeId: giftTypeId,
            giftTypeName: giftTypeName,
            items: [],
          };
        }
        grouped[giftTypeName].items.push(gift);
      });
      return grouped;
    },
  },
  mounted() {
    this.getVipLevels();
    this.getData();
  },
  methods: {
    async getData() {
      this.isLoading = true;
      this.filter.search_keyword = this.filter.search_keyword
        ? this.filter.search_keyword
        : "";
      this.filter.show_deleted = this.$route.query.open_trash ? 1 : 0;
      this.filter.is_active = this.filter.is_active
        ? this.filter.is_active
        : "";
      this.filter.gift_type_id = this.filter.gift_type_id
        ? this.filter.gift_type_id
        : "";
      let query =
        "page=" +
        this.page +
        "&rowsPerPage=" +
        this.rowsPerPage +
        "&show_deleted=" +
        this.filter.show_deleted +
        "&is_active=" +
        this.filter.is_active +
        "&gift_type_id=" +
        this.filter.gift_type_id +
        "&search_keyword=" +
        this.filter.search_keyword;
      await axios
        .get(`gifts?${query}`)
        .then((response) => {
          this.gifts = response.data.data;
          this.count = response.data.count;
          this.serialNoStarting = (this.page - 1) * this.rowsPerPage;
          this.paginationLength = Math.ceil(this.count / this.rowsPerPage);
        })
        .catch(function (error) {
          console.log(error);
          // window.location.href = "/auth/login";
        });
      this.isLoading = false;
    },
    async getVipLevels() {
      try {
        const response = await axios.get("/masters?context=vipLevels");
        this.vipItems = response.data.vipLevels;
        this.masters = response.data;
        console.log("this.vipItems", this.masters);
        this.masters.gift_types.forEach((giftType) => {
          this.giftTypeItems.push({
            id: giftType.id,
            text: giftType.description,
            value: giftType.id,
          });
        });
        console.log("this.vipItems", this.vipItems);
      } catch (e) {
        console.log(e);
      }
    },
    //Generate Excel
    async generateExcel() {
      let query = "search_keyword=" + this.filter.search_keyword;
      let response = await axios.get(`gift_exports?${query}`);
      console.log(response.data.data);
      if (response) {
        window.open(`${response.data.data}`, "_blank");
      }
    },
    async Delete_this(id) {
      this.delete_gift = true;
      await axios
        .post(`/gifts/delete/${this.encryptIt(id)}`)
        .then(() => {
          this.delete_gift = false;
          this.is_deleted_gift = true;
          this.getData();
        })
        .catch(function (error) {
          console.log(error);
          // window.location.href = "/auth/login";
        });
    },
    async Restore_this(id) {
      this.restore_gift = true;
      await axios
        .post(`/gifts/restore/${this.encryptIt(id)}`)
        .then(() => {
          this.restore_gift = false;
          this.is_restored_gift = true;
          this.getData();
        })
        .catch(function (error) {
          console.log(error);
          // window.location.href = "/auth/login";
        });
    },
  },
};
</script>
